import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import logoMark from '@images/logo-mark.png';

/**
 * Официальный логотип SMART-KVADRAT.
 * Используется существующий файл src/images/logo.png без изменений
 * (пропорции и цвета не меняются).
 */
const StyledLogo = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 11px;
  color: inherit;
`;

const StyledMark = styled.img`
  display: block;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  flex: 0 0 auto;
`;

const StyledWord = styled.span`
  font-family: var(--font-sans);
  font-size: ${({ size }) => Math.max(15, size * 0.42)}px;
  font-weight: 600;
  letter-spacing: 0.02em;
  line-height: 1;
  white-space: nowrap;
`;

const Logo = ({ size = 40, withWordmark = true, alt = 'SMART-KVADRAT' }) => (
  <StyledLogo>
    <StyledMark src={logoMark} size={size} alt={alt} width={size} height={size} />
    {withWordmark && <StyledWord size={size}>SMART-KVADRAT</StyledWord>}
  </StyledLogo>
);

Logo.propTypes = {
  size: PropTypes.number,
  withWordmark: PropTypes.bool,
  alt: PropTypes.string,
};

export default Logo;
